import React from 'react';
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button';
import DisplayDate from "./DisplayDate";
import { dateFormat} from '../../utils/DateFormat';

const NotificationItem = ({notification}) => {
  const {SalesmanName, SalesmanImage, Title, CreatedDate} = notification;
  return (
    <li className="media">
      <Avatar
        alt={SalesmanName}
        src={SalesmanImage}
        className=" mr-2"
      />
      <div className="media-body align-self-center">
        <p className="sub-heading mb-0">{Title}</p>
        <span className="meta-date"><small><DisplayDate date={dateFormat(CreatedDate)}/></small></span>
      </div>
    </li>
  );
};

export default NotificationItem;
